/**
 * EmailAuditoriaNivel
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import EmailAuditoriaNivelSchema from '@/schema/EmailAuditoriaNivel.schema'
import EmailNivel from '@/model/resource/EmailNivel'

export default class EmailAuditoriaNivel extends Resource {

  get $schema() {
    return EmailAuditoriaNivelSchema(this)
  }

  get $id() {
    return this.idEmailAuditoriaNivelPk
  }
  set $id(val: ID) {
    this.idEmailAuditoriaNivelPk = val
  }

  get $tag() {
      return this.email
  }
  set $tag(val: TAG) {
      this.email = val
  }

  readonly $name: string = 'EmailAuditoriaNivel'

  readonly $endpoint: string = ''

  idEmailAuditoriaFk: ID = 0

  idEmailAuditoriaNivelPk: ID = 0

  emailNivel: EmailNivel = new EmailNivel()

  email: string = ''

  ativo: boolean = true

}
